
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';
import store from '@/store';
import SessionsModule from '../store/modules/Sessions';
import UserModule from '../store/modules/User';
import SessionSettings from './session/SessionSettings.vue';
import SessionSortBtn from './SessionSortBtn.vue';
import { createInterfaceSound, playInterfaceSound } from '@/service/interfaceSound';

const sessionsModule = getModule(SessionsModule, store);
const userState = getModule(UserModule, store);

@Component({
    components: {
        SessionSettings,
        SessionSortBtn,
    }
})
export default class SessionDrawer extends Vue {
    @Prop({
        required: true,
        type: Boolean,
    })
    public value!: boolean;
    public isOpen: boolean = false;
    private clearedIds: string[] = [];

    get items() {
        return sessionsModule.sortedSessions[userState.user!.id];
    }

    playSlideSound() {
        const audio = createInterfaceSound('/sound/slide.wav');
        playInterfaceSound(audio).catch(error => {
            console.log('Audio playback failed:', error);
        });
    }

    @Watch('isOpen')
    public onToggle(value: boolean) {
        this.$emit('input', value);
        if (value) {
            this.playSlideSound();
        }
    }

    @Watch('value', {
        immediate: true,
    })
    public onValueChange(value: boolean) {
        this.isOpen = value;
    }

    playSpinSound() {
        const audio = createInterfaceSound('/sound/spin.wav');
        playInterfaceSound(audio).catch(error => {
            console.log('Audio playback failed:', error);
        });
    }

    emitUiRippleFromClick(event: MouseEvent) {
        window.dispatchEvent(new CustomEvent('raws-ui-ripple', {
            detail: {
                x: event.clientX,
                y: event.clientY,
            },
        }));
    }
}
